import { IconButton as NovaBaseButtonIcon } from '@fme-nova/components'
import { IconButton as MuiBaseIconButton, IconButtonProps } from '@mui/material'

import { createComponentWrapperWithRef, styled } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiButtonIcon: MsdkStyledComponent<IconButtonProps> = styled(MuiBaseIconButton)`
  color: ${COLORS.action.active};
  &:not(:has(.MuiTypography-root)) {
    aspect-ratio: 1;
  }

  &:has(.MuiTypography-root) {
    height: min-content;
    border-radius: 8px;
  }

  &:hover {
    background-color: ${COLORS.action.hover};
  }

  &.MuiIconButton-colorPrimary {
    color: ${COLORS.primary.main};

    &:hover {
      background-color: ${COLORS.primary.hover};
    }
  }
`

const NovaButtonIcon: MsdkStyledComponent<IconButtonProps> = styled(NovaBaseButtonIcon)`
  color: ${COLORS.action.active};
  width: initial;
  &:not(:has(.MuiTypography-root)) {
    aspect-ratio: 1;
  }
`

export const ButtonIcon = createComponentWrapperWithRef<IconButtonProps>(
  {
    mui: MuiButtonIcon,
    nova: NovaButtonIcon,
  },
  'ButtonIcon',
)
